import { Button, getKeyValue, Tooltip } from "@nextui-org/react";
import { Key, useCallback, useState } from "react";
import {
  ActiveIcon,
  InActiveIcon,
  WatingIcon,
  EditIcon,
  EyeIcon,
} from "@/assets/icons/admin";
// import PartnershipDetailModal from "./partnershipDetailModal";
import EditApplicationForm from "./editPartnership";
import { useGetAllPartnerships } from "@/services/admin.service";
import { PartnershipData } from "@/types";
import Datatable from "@/components/tables/datatable";

const columns = [
  { key: "no", label: "No" },
  { key: "createdDate", label: "Created Date" },
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "contactNo", label: "Tel/WA" },
  { key: "socialMedia", label: "Social Media" },
  { key: "engagement", label: "Engagement" },
  { key: "status", label: "Status" },
  { key: "action", label: "Action" },
];

const fields = [
  { label: "Name", value: "name" },
  { label: "Email", value: "email" },
];

const PartnershipList = () => {
  const query = useGetAllPartnerships;

  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
  const [selectedPartnership, setSelectedPartnership] = useState<
    PartnershipData | undefined
  >(undefined);

  const handleOpenModal = (status: string, partnership: PartnershipData) => {
    setSelectedStatus(status);
    setSelectedPartnership(partnership);
    // setIsModalOpen(true);
  };

  // const handleCloseModal = () => {
  //   refetchAllPartnership();
  //   setIsModalOpen(false);
  // };

  const [isEditingPartnership, setIsEditingPartnership] = useState(false);
  const [editingPartnershipId, setEditingPartnershipId] = useState<string>("");

  const handleEditProvider = (
    partnershipId: string,
    partnership: PartnershipData,
  ) => {
    setIsEditingPartnership(true);
    setSelectedPartnership(partnership);
    setEditingPartnershipId(partnershipId);
  };

  const handleCancelEdit = () => {
    setIsEditingPartnership(false);
  };

  const renderCell = useCallback((data: any[], item: any, columnKey: Key) => {
    switch (columnKey) {
      case "status":
        return (
          <div className="flex items-center">
            {item.status === "APPROVED" && <ActiveIcon />}
            {item.status === "REJECTED" && <InActiveIcon />}
            {item.status === "PENDING" && <WatingIcon />}
          </div>
        );
      case "action":
        return (
          <div className="flex items-center">
            <Tooltip content="Edit">
              <Button
                isIconOnly
                className="transparent-bg h-auto w-auto"
                onClick={() => handleEditProvider(item.id, item)}
              >
                <EditIcon />
              </Button>
            </Tooltip>
          </div>
        );
      case "name":
        return <div className="font-normal text-[#2998FF]">{item.name}</div>;
      case "createdDate":
        return (
          <div className="font-normal">
            {new Date(item.createdAt).toLocaleString()}
          </div>
        );
      case "socialMedia":
        return (
          <div className="max-w-40 truncate font-normal">
            {item.platforms
              .map((platform: any) => platform.platformName)
              .join(", ")}
          </div>
        );
      case "contactNo":
        return <div className="font-normal">+{item.contactNo}</div>;
      case "no":
        return (
          <div className="font-normal">
            {data.findIndex((row) => row.id === item.id) + 1}
          </div>
        );
      default:
        return (
          <div className="font-normal">
            {getKeyValue(item, columnKey as string) || "-"}
          </div>
        );
    }
  }, []);

  return (
    <div>
      {isEditingPartnership ? (
        <EditApplicationForm
          onCancel={handleCancelEdit}
          partnershipId={editingPartnershipId}
          partnership={selectedPartnership || undefined}
        />
      ) : (
        <div className="partnership-list">
          <div className="mb-4 text-xl font-bold text-white">
            Partnership List
          </div>

          <Datatable
            columns={columns}
            renderCell={renderCell}
            query={query}
            customQueryFilter={{
              filter: selectedStatus,
            }}
            searchFields={fields}
          />

          {/* {isModalOpen && ( */}
          {/*   <PartnershipDetailModal */}
          {/*     isOpen={isModalOpen} */}
          {/*     onClose={handleCloseModal} */}
          {/*     status={selectedStatus!} */}
          {/*     partnership={selectedPartnership || undefined} */}
          {/*   /> */}
          {/* )} */}
        </div>
      )}
    </div>
  );
};

export default PartnershipList;
